import copilotLogo from '../../../../assets/images/etl-copilot5.png';

export const ETL_COPILOT = {
  LOGO: copilotLogo,
};
